import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateConditionsState from './conditions';
import updateDatasetConditionsState from './datasetConditions';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';

const handlers = {
  ...updateConditionsState,
  ...updateDatasetConditionsState,
  ...updateDatasetSettingsState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
